import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FlowMixin extends Vue {
  get opositePredicates() {
    return [ 'NOT_UNIQUE', 'IS_NOT_BOT', 'NOT_EQUALS', 'NOT_CONTAINS' ];
  }

  isOppositeRule(predicate: string) {
    return this.opositePredicates.includes(predicate);
  }

  generate_name(item: any, isReturnString: boolean = true, hideNumber: boolean = false) {
    if (item.name) {
      return item.name;
    }

    const conditions = Object.keys(item.conditions).map((e: any) => {
      let condition = item.conditions[e];
      let values = condition.values;

      if (typeof values === 'function')
        return condition;

      let value = Array.isArray(values) ? values : [values];
      (value as any).target = e;
      (value as any).predicate = condition.predicate;
      return value;
    });

    let result: FlowCondition[] = [];

    const zeroTimeFormat = function(time: number) {
      return time < 10 ? '0' + time : '' + time;
    };

    conditions.forEach((e: any) => {
      if (typeof e[0] === 'object') {
        for(let i in e) {
          if(e[i] && typeof e[i] === 'object') {
            if(e.target === 'timeOfDay') {
              const { from, to } = e[i];

              return result.push({
                name: `${zeroTimeFormat(from.hour)}:${zeroTimeFormat(from.minute)} - ${zeroTimeFormat(to.hour)}:${zeroTimeFormat(to.minute)}`,
                predicate: e[i].predicate,  
              })
            }

            if(e.target === 'visitCap') {
              const values = Object.keys(e[i]).map((item=>{
                switch (item){
                  case 'perHour': return  this.t('For 1 hour');
                  case 'perDay': return  this.t('For 24 hours');
                  case 'perMonth': return  this.t('For 1 month');
                }
              }));
              
              const firstOption = values[0];
              
              if(typeof firstOption !== 'undefined') {
                 result.push({
                  name: `${firstOption} ${(!hideNumber && values.length > 1 && '(+' + (values.length - 1) + ') ') || ''}`,
                  predicate: e[i].predicate,
                  count: (values.length - 1)
                });
              }
              return;
            }
            
            let val = e[i].values[0];
            if (val === '' || val === `[${this.t('Empty Value')}]`) {
              val = `[${this.t('Empty')}]`;
            }

            if(typeof val !== 'undefined') {
              let name = `${e[i].parameter || this.t('Empty')}=${val} ${(!hideNumber && e[i].values.length > 1 && '(+' + (e[i].values.length - 1) + ') ') || ''}`;
              result.push({
                name: name,
                predicate: e[i].predicate,
                count: (e[i].values.length - 1)
              });
            }
          }
        }
      } else if(e.length > 0) {
        if (e[0] === '' || e[0]) {
          if(e.target !== 'timezone') {
            let name = '';
            let predicate = e.predicate;
            switch (e[0]) {
              case 'UNIQUE':
                name = e.target==='uniqOfferViewer' ? this.t('Is Not Recurring') : this.t('Unique')
                break;
              case 'NOT_UNIQUE':
                name = e.target==='uniqOfferViewer' ? this.t('Is Recurring') : this.t('Non-Unique')
                predicate = 'NOT_UNIQUE';
                break;
              case 'IS_NOT_BOT':
                name = this.t('Not bot');
                predicate = 'IS_NOT_BOT';
                break;
              case 'IS_NOT_WEB_VIEW':
                name = this.t('Not WebView');
                predicate = 'NOT_EQUALS';
                break;
              case 'IS_WEB_VIEW':
                name = this.t('Is WebView');
                predicate = 'IS_WEB_VIEW';
                break;
              case 'IS_BOT':
                name = this.t('Bot');
                break;
              case 'IS_CRAWLER':
                name = this.t('Is Crawler');
                break;
              case 'IS_NOT_CRAWLER':
                name = this.t('Is Not Crawler');
                predicate = 'NOT_EQUALS';
                break;
              case 'IS_PROXY':
                name = this.t('Is Proxy');
                break;
              case 'IS_IP_DATACENTER':
                name = this.t('IPs From Data Centers');
                break;
              case 'IS_NOT_IP_DATACENTER':
                name = this.t('IPs Not From Data Centers');
                predicate = 'NOT_EQUALS';
                break;
              case 'IS_IP_BLACKLISTED':
                name = this.t('IPs From Blacklists');
                break;
              case 'IS_NOT_IP_BLACKLISTED':
                name = this.t('IPs Not From Blacklists');
                predicate = 'NOT_EQUALS';
                break;
              case 'IP_WITH_FREQUENT_CAMPAIGN_EVENTS':
                name = this.t('Frequent in campaign');
                break;
              case 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS':
                name = this.t('Not Frequent in campaign');
                predicate = 'NOT_EQUALS';
                break;
              case 'IP_WITH_FREQUENT_EVENTS':
                name = this.t('Frequent');
                break;
              case 'IP_NOT_WITH_FREQUENT_EVENTS':
                name = this.t('Not Frequent');
                predicate = 'NOT_EQUALS';
                break;
              case 'IS_NOT_PROXY':
                name = this.t('Not Proxy');
                predicate = 'NOT_EQUALS';
                break;
              default:
                let firstOption = e[0].trim();
                if (firstOption === '') {
                  firstOption = `[ ${this.t('Empty')} ]`;
                }
                if(e.target==='country'){
                  firstOption = this.$store.getters.countryListPlusGlobal.find((country)=>country?.code===firstOption)?.name || firstOption
                }
                name = `${firstOption} ${(!hideNumber && e.length > 1 && '(+' + (e.length - 1) + ') ') || ''}`;
            }

            result.push({
              name: name,
              predicate: predicate,
              count: (e.length - 1)
            });
          }
        } else {
          result.push({
            name: e.target + ' (' + (e.length - 1) + ') ',
            predicate: 'EQUALS'
          });
        }
      }
    });

    return isReturnString
      ? result
        .map((item: any) => item.name)
        .join(' | ')
      : result;
  }
}
